import { IconElementsProps } from "../icon-elements-props.type";
import { iconSizes } from "../icon-sizes";

export function Assemblies(props: IconElementsProps) {
  const {
    className,
    primaryColor = "#00083C",
    width,
    height,
    size = "S",
  } = props;

  return (
    <svg
      className={className}
      style={{
        minWidth: width || iconSizes[size],
        minHeight: width || iconSizes[size],
      }}
      width={width || iconSizes[size]}
      height={height || iconSizes[size]}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 3.84615C20 1.72205 18.278 0 16.1538 0H3.84615C1.72205 0 0 1.72205 0 3.84615V16.1538C0 18.278 1.72205 20 3.84615 20H16.1538C18.278 20 20 18.278 20 16.1538V3.84615ZM18.4615 3.84615V16.1538C18.4615 17.4287 17.4287 18.4615 16.1538 18.4615H3.84615C2.57128 18.4615 1.53846 17.4287 1.53846 16.1538V3.84615C1.53846 2.57128 2.57128 1.53846 3.84615 1.53846H16.1538C17.4287 1.53846 18.4615 2.57128 18.4615 3.84615Z"
        fill={primaryColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 7.15909V5.34091C8.75 4.46182 8.03818 3.75 7.15909 3.75H5.34091C4.46182 3.75 3.75 4.46182 3.75 5.34091V7.15909C3.75 8.03818 4.46182 8.75 5.34091 8.75H7.15909C8.03818 8.75 8.75 8.03818 8.75 7.15909ZM7.38636 5.34091V7.15909C7.38636 7.28455 7.28455 7.38636 7.15909 7.38636H5.34091C5.21545 7.38636 5.11364 7.28455 5.11364 7.15909V5.34091C5.11364 5.21545 5.21545 5.11364 5.34091 5.11364H7.15909C7.28455 5.11364 7.38636 5.21545 7.38636 5.34091Z"
        fill={primaryColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9375 5H14.0625C14.58 5 15 4.72 15 4.375C15 4.03 14.58 3.75 14.0625 3.75H10.9375C10.42 3.75 10 4.03 10 4.375C10 4.72 10.42 5 10.9375 5Z"
        fill={primaryColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8654 8.75H16.6346C17.1123 8.75 17.5 8.47 17.5 8.125C17.5 7.78 17.1123 7.5 16.6346 7.5H10.8654C10.3877 7.5 10 7.78 10 8.125C10 8.47 10.3877 8.75 10.8654 8.75Z"
        fill={primaryColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 14.6591V12.8409C8.75 11.9618 8.03818 11.25 7.15909 11.25H5.34091C4.46182 11.25 3.75 11.9618 3.75 12.8409V14.6591C3.75 15.5382 4.46182 16.25 5.34091 16.25H7.15909C8.03818 16.25 8.75 15.5382 8.75 14.6591ZM7.38636 12.8409V14.6591C7.38636 14.7845 7.28455 14.8864 7.15909 14.8864H5.34091C5.21545 14.8864 5.11364 14.7845 5.11364 14.6591V12.8409C5.11364 12.7155 5.21545 12.6136 5.34091 12.6136H7.15909C7.28455 12.6136 7.38636 12.7155 7.38636 12.8409Z"
        fill={primaryColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9375 12.5H14.0625C14.58 12.5 15 12.22 15 11.875C15 11.53 14.58 11.25 14.0625 11.25H10.9375C10.42 11.25 10 11.53 10 11.875C10 12.22 10.42 12.5 10.9375 12.5Z"
        fill={primaryColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8654 16.25H16.6346C17.1123 16.25 17.5 15.97 17.5 15.625C17.5 15.28 17.1123 15 16.6346 15H10.8654C10.3877 15 10 15.28 10 15.625C10 15.97 10.3877 16.25 10.8654 16.25Z"
        fill={primaryColor}
      />
    </svg>
  );
}
